<template>
	<v-app>
		<v-content>
			<v-container class="fill-height" fluid>
				<div class="rule">
					<h1>LINEミニアプリ利用規約</h1>
					<dl class="dl-block">
						<p>
						この規約（以下「本規約」といいます）は、{{shop_name}}（以下「当社」といいます）が提供するLINEミニアプリ（以下「本アプリ」といいます）のすべてのサービス（本アプリを含み、以下「本サービス」といいます）の利用に関する条件を、本サービスを利用するお客様（以下「お客様」といいます）と当社との間で定めるものです。<br>
                        本サービスの利用に際しては、本規約の全文を必ずお読みいただいた上で、本規約に同意いただく必要があります。お客様は、本規約内容に同意いただいた場合にのみ、本サービスをご利用いただけます。</p><br>
						<p>
                        本アプリは、LINE株式会社（以下「配布元」といいます）が提供する「LINE Mini App（ラインミニアプリ）」のプラットフォームを利用し、株式会社USEN（以下「開発会社」といいます）が開発したアプリケーションです。<br>
                        当社は開発会社に対して、本サービスの提供に関する業務の一部を委託しています。<br>
                        お客様はLINE規約(https://terms.line.me/line_terms/?lang=ja)に同意しなければ、本サービスを利用することができません。お客様が本サービスを利用した場合、LINE規約に同意したものとみなします。</p><br>

						<dt>第1条 本アプリのご利用にあたって</dt>

						<dd>お客様の携帯電話端末（以下「端末機」といいます）から本アプリを起動し、認証画面の各種事項を許可すると、本アプリをご利用いただけます。当社は、当社所定の情報の登録、その他当社が必要と判断する条件を満たしたお客様に本サービスを提供します。本アプリは無料でご利用頂けますが、本サービスの利用にあたり、端末機からのアクセス、メッセージなどの受信に必要な通信費はお客様ご自身の負担となります。お客様が本アプリ及び本サービスのご利用に際して行った一切の行為、その結果及び当該行為により被った損害について、当社は何等の責任も負わないものとします。</dd>

						<dt>第2条 ユーザーIDの管理</dt>

						<dd></dd>
                        お客様は、自己の責任において、本サービスに関するユーザーIDを適切に管理及び保管するものとし、これを第三者に利用させ、または貸与、譲渡、名義変更、売買等をしてはならないものとします。<br>
                        ユーザーIDの管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任はお客様が負うものとし、当社は一切の責任を負いません。<br>
                        ハッキング等、第三者の行為が原因でお客様のユーザーＩＤが利用された場合、お客様ご自身の責任で対応するものとし、当社及び配布元は一切の責任を負いません。
						<dt>第3条 禁止行為について</dt>
						<dd>
                        お客様は、本サービスのご利用にあたり、以下の行為またはそのおそれのある行為を行ってはならないものとします。<br>
                        (1)他のお客様、当社または第三者に不利益または損害を与える行為<br>
                        (2)公序良俗に反する行為<br>
                        (3)法令に違反する行為<br>
                        (4)当社の書面による事前の承認を得ずに、本サービスに関連して営利を追求する行為<br>
                        (5)当社による本サービスの運営を妨害する行為<br>
                        (6)本サービスの信用を失墜、毀損させる行為<br>
                        (7)当社の承認した以外の方法で本サービスを利用する行為<br>
                        (8)本サービスを譲渡、貸与、公衆送信、使用許諾する行為<br>
                        (9)本サービスを複製、翻案、編集、改変、逆アセンブル、逆コンパイル、リバースエンジニアリングする行為<br>
                        (10)コンピュータウイルス等を使用し、第三者に提供する行為、あるいはそのおそれのある行為<br>
                        (11)その他、当社が不適切と判断する行為
						</dd>

						<dt>第４条 知的財産権について</dt>
						<dd>本サービスに関する一切の特許権、実用新案権、意匠権、著作権、商標権等の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。以下「知的財産権」といいます）は全て当社、配布元及び開発会社または当該権利を有する第三者に帰属します。お客様は、本サービスのご利用にあたって、一切の権利を取得することはなく、当社は、お客様に対し、本サービスに関する知的財産権について、本サービスを本規約に従ってお客様の端末機においてのみ使用できる譲渡不能の権利として許諾するものです。したがって、お客様は個人で楽しむ目的（著作権法第30条第１項の範囲での私的使用）でのみ本サービスを利用できます。また、お客様は本サービスを当社から提供された状態でのみ利用するものとし、本サービスに関する情報の全部または一部を、当社の了解を得ずに、複製、改変、貸与、配布などにより転用してはなりません。</dd>

						<dt>第5条 秘密保持</dt>
						<dd>お客様は、本サービスに関連して当社及び配布元がお客様に対して秘密に取り扱うことを求めて開示した非公知の情報について、当社及び配布元の事前の書面による承諾がある場合を除き、秘密に取扱うものとします。</dd>

						<dt>第6条 お客様情報の取り扱い</dt>
						<dd>
                        当社及び配布元は、当社及び配布元の定める方法でお客様情報を取得します。<br>
                        当社及び配布元によるお客様情報の取扱いは、当社及び配布元がそれぞれ別途定めるプライバシーポリシーによるものとし、お客様はこのプライバシーポリシーに従って当社及び配布元がお客様情報を取扱うことについて同意するものとします。<br>
                        当社及び配布元は、お客様が本アプリを通じて提供した情報、データ等を、個人を特定できない形での統計的な情報として利用及び公開することができるものとし、お客様はこれに異議を唱えないものとします。</dd>

						<dt>第7条 本サービスの提供中止について</dt>
						<dd>
                        当社は、お客様が本規約に違反した場合、当該お客様に対して本サービスの提供を中止することがあります。<br>
                        当社、配布元及び開発会社は、天災地変等の不可抗力により本サービスのシステムに支障を来たした場合、必要と判断すれば、あらかじめお客様に通知することなく、いつでも本サービスの全部または一部の提供を中止することができるものとします。<br>
                        前二項に基づく本サービスの提供の中止により、お客様または第三者に損害が生じた場合であっても、当社、配布元及び開発会社は、いかなる責任も負いません。</dd>

						<dt>第8条 本サービスの変更・一時中断・廃止について</dt>
						<dd>
                        当社、配布元及び開発会社は、本サービスの内容を必要に応じて変更することがあります。また、メンテナンスや内容更新のため本サービスの提供を一時中断、あるいは本サービスの廃止を行う場合があります。当該変更または一時中断、廃止によってお客様または第三者に損害が生じた場合であっても、当社、配布元及び開発会社は、いかなる責任も負いません。</dd>

						<dt>第9条 本規約の改訂</dt>
						<dd>
                        当社は、以下の場合に、当社の裁量により、本規約を変更することができるものとします。<br>
                        本規約の変更が、お客様の一般の利益に適合するとき。<br>
                        本規約の変更が、本サービスの利用の目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき。<br>
                        当社は本規約を変更する場合、本規約を変更する旨並びに改定後の本規約の内容及びその効力発生日を、効力発生日の1か月前までに本アプリ内に掲示することによってお客様に告知するものとします。<br>
                        変更後の本規約の効力発生日以降にお客様が本サービスを利用したときは、お客様が本規約の変更に同意したものとみなします。
						</dd>


						<dt>第10条 免責事項について</dt>
						<dd>
                        当社、配布元及び開発会社は、本サービスに関する情報及びデータの正常性、信頼性、正確性を保証するものではありません。本サービスにかかる情報によりお客様または第三者に損害が生じた場合であっても、当社、配布元及び開発会社は、その損害についていかなる責任も負いません。また、当社、配布元及び開発会社は、本サービスの利用に起因するソフトウェア、ハードウェア上の事故、お客様間またはお客様と第三者の間において生じたトラブル、その他の事故などによる全ての損害についても、いかなる責任も負いません。<br>
                        当社、配布元及び開発会社は、本サービスの提供の中断、停止、終了、利用不能または変更、お客様が本サービスに送信したメッセージまたは情報の削除または消失、お客様の登録の抹消、本サービスの利用による登録データの消失または機器の故障もしくは損傷、その他本サービスに関してお客様が被った損害(以下「お客様損害」といいます。)につき、賠償する責任を一切負いません<br>
                        お客様損害の発生が当社の故意又は重大な過失による場合は、前項の規定は適用しません。</dd>

						<dt>第11条 損害賠償について</dt>
						<dd>
                        本規約に違反して権利侵害等の問題が発生した場合、お客様は、自己の負担と責任においてかかる問題を解決するとともに、当社、配布元及び開発会社に何等の迷惑または損害を与えないものとし、当社、配布元及び開発会社に損害を与えたときは、全ての損害を賠償するものとします。</dd>

						<dt>第12条 分離可能性</dt>
						<dd>本規約のいずれかの条項またはその一部が、消費者契約法その他の法令により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。</dd>

						<dt>第13条 準拠法、協議、管轄</dt>
						<dd>本規約の解釈及び運用は日本国法に準拠します。 本サービスに関連してお客様、当社ないし第三者との間で疑義、問題が生じた場合、その都度誠意をもって協議し、解決を図るものとします。 協議によっても疑義、問題が解決しない場合、これらに関する紛争は当社の本店所在地を管轄する地方裁判所または簡易裁判所を第一審の専属的合意管轄裁判所とします。</dd>

						<p class="si">附則<br>2021年7月1日 施行</p>

					</dl>
				</div>

			</v-container>
		</v-content>
	</v-app>
</template>

<script>
export default {
	data: () => ({
			shop_name: null,
  }),
  async created() {
    const shop_id = this.getUrlGetParam('shop_id')
    try {
      //ページ表示に必要な情報を取得
      var shopReq = { params: {
        sid: shop_id
      }}
      var shopRes = await this.apiCall('/user/shop', shopReq)

      this.shop_name = shopRes.shop_name

    } catch(e) {
      this.callDialog('エラー', shopRes.message, 3);
    }
  }
}
</script>

<style scoped>
h1 {
	font-family: YuGothic;
	font-weight: bold;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: #333;
	margin-bottom: 20px;
}

.rule {
	padding-top: 10px;
}

dl {
	font-size: 13px;
}

dt {
	font-family: YuGothic;
	font-weight: bold;
	font-size: 16px;
	text-align: center;
	color: #333;
	margin: 30px 0 10px;
}

.si {
	margin-top: 30px;
}
</style>
